import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllSettingsApi } from "../Apis/settings/settings";

export const fetchgetAllSettingsApi = createAsyncThunk(
  "getAllSettingsApi/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllSettingsApi();
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  data: [],
  isLoading: false,
  status: null,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchgetAllSettingsApi.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.status = null;
      })
      .addCase(fetchgetAllSettingsApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.status = action.payload.status;
      })
      .addCase(fetchgetAllSettingsApi.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default settingsSlice.reducer;
